import {
  ProductNotificationGroupBy,
  type BackInStockProduct,
} from "@redotech/redo-customer-common/customer-product-notification/customer-product-notification";
import { memo } from "react";
import type { BisFilterProps } from "./filter-props";
import { ProductGroupDetail } from "./product-group-detail";
import { VariantDetail } from "./variant-detail";

export const ProductDetailView = memo(function ProductDetailView({
  product,
  refetchAllProducts,
  subscriberSearch,
  setSubscriberSearch,
  ...filterProps
}: {
  product: BackInStockProduct;
  refetchAllProducts: () => void;
  subscriberSearch: string;
  setSubscriberSearch: (q: string) => void;
} & BisFilterProps) {
  const sharedProps = {
    subscriberSearch,
    setSubscriberSearch,
    refetchAllProducts,
    ...filterProps,
  };

  switch (product.groupBy) {
    case ProductNotificationGroupBy.PRODUCT:
      return <ProductGroupDetail product={product} {...sharedProps} />;
    case ProductNotificationGroupBy.VARIANT:
      return (
        <VariantDetail
          variant={{
            productId: product.productId,
            variantId: product.variantId,
            name: product.name,
            sku: product.sku,
            imageUrl: product.imageUrl,
            waitingCount: product.waitingCount,
            notifiedCount: product.notifiedCount,
            price: product.price,
          }}
          {...sharedProps}
        />
      );
  }
});
